import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filingFormAPI } from '../../utilities/api';
import { FilingForm } from '../../utilities/interfaces/FilingForm';

// represents the shape of the slice in state
interface FilingFormState {
  value: any;
}

const initialState: FilingFormState = {
  value: [],
};

const filingFormSlice = createSlice({
  name: 'stateFilingForm',
  initialState,
  reducers: {
    // add new filing item
    addFilingFormItem(state, action: PayloadAction<FilingForm>) {
      // its okay to do this because immer makes it immutable
      state.value.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllFilingForms.fulfilled, (state, action) => {
      state.value = action.payload;
    });
    builder.addCase(getFilingFormsByType.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllFilingForms = createAsyncThunk('stateFilingForm/getFilingForms', async () => {
  const response = await filingFormAPI.getFilingForms();
  return response;
});

export const getFilingFormsByType = createAsyncThunk(
  'stateFilingForm/getFilingFormsByType',
  async (id: number) => {
    const response = await filingFormAPI.getFilingFormsByType(id);
    return response;
  }
);

export const { addFilingFormItem } = filingFormSlice.actions;
export default filingFormSlice.reducer;
